if (!customElements.get('collection-layout')) {
  class CollectionLayout extends HTMLElement {
    defaultLayout = 'grid';
    constructor() {
      super();
    }

    connectedCallback() {
      this.addEventListener('change', this.onChange.bind(this));

      if (window.location.hash === '#list' || window.location.hash === '#grid') {
        const savedLayout = window.location.hash.substring(1);
        setCookie('collection_layout', savedLayout, { expires: 30, path: '/' });
      }

      // Set initial layout from cookie if available
      const savedLayout = getCookie('collection_layout');
      const collectionContainer = this.closest('.collection');

      if (!collectionContainer) return;

      if (savedLayout) {
        collectionContainer.dataset.layout = savedLayout;
        const layoutSelector = this.querySelector(`input[type="radio"][value="${savedLayout}"]`);
        if (layoutSelector) {
          layoutSelector.checked = true;
        }
      } else {
        collectionContainer.dataset.layout = this.defaultLayout;
        const layoutSelector = this.querySelector(
          `input[type="radio"][value="${this.defaultLayout}"]`,
        );
        if (layoutSelector) {
          layoutSelector.checked = true;
        }
      }
    }

    onChange(event) {
      const selectedLayout = event.target.value;
      const collectionContainer = this.closest('.collection');
      if (collectionContainer) {
        collectionContainer.dataset.layout = selectedLayout;
      }
      setCookie('collection_layout', selectedLayout, { expires: 30, path: '/' });
      window.location.hash = `#${selectedLayout}`;
    }
  }
  customElements.define('collection-layout', CollectionLayout);
}
